const stickyATC = document.querySelector('.sticky-atc');
const stickyATCSelect = stickyATC.querySelectorAll('select');
const stickyATCButton = stickyATC.querySelector('button');

const productVariantOptions = document.querySelectorAll('.product .product-form__option-selector .block-swatch');
const productFormBuyButtons = document.querySelector('.product .product-form__buy-buttons');
const productFormButton = document.querySelector('.product .product-form__add-button');

function numberToEuro(number){
    const euroValue = (parseInt(number) / 100).toFixed(2).replace(".", ",") + "€";
    return euroValue;
}

/* SCALAPAY PRICE */

const productScalapay = document.querySelector('.product .product-scalapay-information');
const productScalapayPrice = productScalapay.querySelector('#product-price-scalapay');

function updateProductScalapayPrice(){
  setTimeout(function() {
    const productPrice = document.querySelector('.product .price-list .price');
    const regex = /(\d+,\d{2}€)/;
    const price = productPrice.textContent.match(regex)[0];
    const newPrice = numberToEuro((parseInt(price.replace(',', '').replace('€', ''), 10))/3);
    productScalapayPrice.innerHTML = `${newPrice}`;
  }, 100)

}
updateProductScalapayPrice();

// SCROLL

window.addEventListener('scroll', () => {

    const mobileWidth = 1130;
    const desktopWidth = 670;

    if(window.innerWidth < 750){
        if(window.scrollY > mobileWidth ){
            stickyATC.setAttribute('open', '');
        }else{
            stickyATC.removeAttribute('open');
        }
    }else{ 
        if(window.scrollY > desktopWidth ){
            stickyATC.setAttribute('open', '');
        }else{
            stickyATC.removeAttribute('open');
        }
    }
})

// FUNCTION

function updateProductOption(optionName){

    // PRODUCT
    for(let i=0;i<productVariantOptions.length;i++){
        const input = productVariantOptions[i].querySelector('input');
        if(input.value == optionName){
            // SELECT
            const label = productVariantOptions[i].querySelector('label');
            label.click();
            input.checked = true;
            const inputId = productFormBuyButtons.querySelector('input[name=id]');
            inputId.value = productVariantOptions[i].dataset.variantId;

            // PRICE
            const labelPrice = productVariantOptions[i].querySelector('label .price');
            const stickyPrice = stickyATCButton.querySelector('.price__regular');
            stickyPrice.innerHTML = `${labelPrice.textContent}`;


            setTimeout(function() {

                const productButton = document.querySelector('.product .product-form__add-button');

                let buttonText;
                if(productButton.getAttribute('disabled') == null){
                    buttonText = `Ajouter au panier`;
                }else{
                    buttonText = `Indisponible`;
                }

                productButton.innerHTML = `
                <span class="loader-button__text">${buttonText} | <span class="price__regular">${labelPrice.textContent}</span></span>
                <span class="loader-button__loader" hidden>
                <div class="spinner">
                    <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                    <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                    </svg>
                </div>
                </span>

            `;
            },100)

        }
    }

    //STICKY
    stickyATCSelect.forEach(select => {
        select.value = optionName;
    })

}

// SELECTS EVENTS

stickyATCSelect.forEach(select => {
    select.addEventListener('change', () => {
        updateProductOption(select.value);
        updateProductScalapayPrice();
    })
})

productVariantOptions.forEach(option => {
    option.addEventListener('change', () => {
        const input = option.querySelector('input');
        updateProductOption(input.value);
        updateProductScalapayPrice();
    })
})

stickyATCButton.addEventListener('click', () => {
    productFormButton.click();
})